import { query, request } from '@/utils/request';
import { ApplyListParams } from '../entities';

/**
 * 获取工资申报列表
 * @param params
 * @returns
 */
export async function fetchWageApplyList(data?: ApplyListParams) {
  return request('/zlb/api/expense/wage/apply/list', {
    data,
    method: 'POST',
  });
}

export async function rejectApplyForm(data) {
  return request('/zlb/api/expense/wage/apply/reject', {
    data,
    method: 'POST',
  });
}

// 作废申请单
export async function nullifyApplyForm(data) {
  return request('/zlb/api/expense/wage/apply/nullify', {
    data,
    method: 'POST',
  });
}
/**
 * 获取申报单详情
 * @param params
 * @returns
 */
export async function fetchWageApplyDetail(data) {
  return request('/zlb/api/expense/wage/apply/detail', {
    data,
    method: 'POST',
  });
}

/**
 * 删除申报单
 * @param params
 * @returns
 */
export async function deleteWageApply(data) {
  return request('/zlb/api/expense/wage/apply/delete', {
    data,
    method: 'POST',
  });
}

/**
 * 获取申报次数
 * @param params
 * @returns
 */
export async function fetchWageApplyTimes(data) {
  return request('/zlb/api/expense/wage/apply/times', {
    data,
    method: 'POST',
  });
}

/**
 * 校验次数
 * @param params
 * @returns
 */
export async function checkTimes(data) {
  return request('/zlb/api/expense/wage/apply/check-times', {
    data,
    method: 'POST',
  });
}

/**
 * 保存申报单
 * @param params
 * @returns
 */
export async function saveWageApply(data) {
  return request('/zlb/api/expense/wage/apply/save', {
    data,
    method: 'POST',
  });
}

/**
 * 提交申报单
 * @param params
 * @returns
 */
export async function submitWageApply(data) {
  return request('/zlb/api/expense/wage/apply/submit', {
    data,
    method: 'POST',
  });
}

/**
 * 搜索栏状态选项
 */
export async function fetchStatusOptions(data) {
  return request('/zlb/api/expense/wage/apply/status/list', {
    data,
    method: 'POST',
  });
}

/**
 * 获取工资申报列表
 * @param data
 * @returns
 */
export async function fetchWageAuditList(data?: ApplyListParams) {
  return request('/zlb/api/expense/wage/apply/audit/list', {
    data,
    method: 'POST',
  });
}

/**
 * 文件流上传
 */
export async function uploadEncryptedFile(data) {
  return request('/zlb/api/fileServer/secure/upload', {
    data,
    method: 'POST',
    headers: {
      'Content-type': 'multipart/form-data',
    },
  });
}

/**
 * 导入任务提交
 * @param data
 * @returns
 */
export async function importSubmit(data) {
  return request('/zlb/api/expense/task/imports/submit', {
    data,
    method: 'POST',
  });
}

/**
 * 导入任务结果
 */
export async function importResult(data) {
  return request('/zlb/api/expense/task/imports/result', {
    data,
    method: 'POST',
  });
}

/**
 * 导出明细获取fileId
 * @param data
 * @returns
 */
export async function exportDetails(data) {
  return request('/zlb/api/expense/wage/apply/export', {
    data,
    method: 'POST',
  });
}
/**
 * 导出明细通过fileId获取文件流
 */
export async function downloadEncryptedFile(fileId) {
  return request(`/zlb/api/fileServer/secure/download/${fileId}`, {
    responseType: 'blob',
  });
}
// 批量导入台账失败查询Excel导出结果
export async function ledgerExportFile(serialCode) {
  return request(`/zlb/api/financial/common/export-result/${serialCode}`, {
    responseType: 'blob',
  });
}
/**
 * 导出机构启用的模板
 */
export async function exportActiveTemplate() {
  return request('/zlb/api/expense/wage/config/template/apply/export-active');
}

/**
 * ----------------------------------------------------------------------------
 * 支付流水
 */

/**
 * 查询工资支付流水
 * @param params
 * @returns
 */
export async function getSalaryFlowList(data) {
  return query('/zlb/api/expense/wage/payment/query', {
    data,
    method: 'POST',
  });
}

/**
 * 拆分流水
 */
export async function splitPayment(data) {
  return request('/zlb/api/expense/wage/payment/split', {
    data,
    method: 'POST',
  });
}

/**
 * 支付流水设置预算
 * @param params
 * @returns
 */
export async function salaryFlowSetBudget(data) {
  return query('/zlb/api/expense/wage/payment/budget/set', {
    data,
    method: 'POST',
  });
}

/**
 * 处理异常的工资支付流水
 */
export async function mainProces(data) {
  return request('/zlb/api/expense/wage/payment/process', {
    data,
    method: 'POST',
  });
}

/**
 * 工资申请支付
 * @param params
 * @returns
 */
export async function salaryPayment(data) {
  return query('/zlb/api/expense/wage/payment/pay', {
    data,
    method: 'POST',
  });
}

// --------------- 以下是发放对象管理

/**
 * 获取发放对象列表
 */
export async function getPayoffUserList(params) {
  return request('/api/zlbuser/identity/list/payoffUser', {
    params,
  });
}

/**
 * 批量确认发放对象
 */
export async function surePayoffUser(data) {
  return request('/api/zlbuser/identity/sure/payoffUser', {
    data,
    method: 'POST',
  });
}

/**
 * 新增、编辑发放对象
 */
export async function savePayoffUser(data) {
  return request('/api/zlbuser/identity/save/payoffUser', {
    data,
    method: 'POST',
  });
}

/**
 * 获取发放对象详情
 */
export async function getPayoffUserDetail(params) {
  return request('/api/zlbuser/identity/detail/payoffUser', {
    params,
  });
}

/**
 * 新增、编辑用户唯一性校验
 */
export async function checkPayoffUser(data) {
  return request('/api/zlbuser/identity/check/payoffUser', {
    data,
    method: 'POST',
  });
}

/**
 * 发放对象启用、停用操作
 */
export async function setPayoffUserState(data) {
  return request('/api/zlbuser/identity/state/payoffUser', {
    data,
    method: 'POST',
  });
}

/**
 * 人员性质枚举
 */
export async function getPersonnelNature() {
  return request('/api/user/dictionary/personnelNature');
}

/**
 * 匹配用户枚举
 */
export async function getInstitutionUserList(params) {
  return request('/api/zlbuser/identity/list/institutionUser', {
    params,
  });
}

/**
 * 下载模板接口
 */
export async function getTemplate(params) {
  return request('/api/user/import/template', {
    params,
  });
}

/**
 * 上传模板接口
 */
export async function uploadTemplate(data) {
  return request('/api/user/import/upload', {
    data,
    method: 'POST',
  });
}

/**
 * 获取银行列表
 */
export async function getBankList(params) {
  return request('/zlb/api/pay/bankCard/bank/list', {
    params,
  });
}

/**
 * 下载失败记录文件
 * @param params
 */
export async function downloadFailFile(params) {
  return request('/api/zlbuser/identity/import/record', {
    responseType: 'blob',
    params,
  });
}

// 导出账户校验结果
export const exportBankCardOuterUserCheckResult = async data => {
  return query('/zlb/api/pay/bankCard/outer-user/check/export', { method: 'POST', data });
};

// 获取导出账户校验结果
export const getBankCardOuterUserCheckResult = async params => {
  return query('/zlb/api/pay/bankCard/outer-user/check/export/result', { params });
};

// --------------- 以上是发放对象管理
// --------------- 以下是工资项目管理

/**
 * 工资项目列表
 */
export async function getConfigItemList(data) {
  return request('/zlb/api/expense/wage/config/item/list', {
    data,
    method: 'POST',
  });
}

/**
 * 查询流水单的相关指标信息
 * @param  {
 * }
 * "reimburseType": "@string",//报销类型,必填（11010	公务出行，11011	会议活动，11012	学习培训，11013	办公用品，11014：公务接待，11015：一般事项，11016：工资发放）
  "orgId": 0,//机构ID,必填
  "departmentId": 0,//部门id,必填
  "year": 0,//年份
  "amount": 0//报销金额
  "govExpendEconomicClassifyCode":""//政府支出经济分类编码
  "depExpendEconomicClassifyCode":""//部门支出经济分类编码 
 * @returns 
 */
export async function getBudgetInfo(data) {
  return query('/zlb/api/expense/budget/query-budget', {
    data,
    method: 'POST',
  });
}
// 处理异常
export async function processException(data) {
  return request('/zlb/api/expense/wage/payment/query-positive', {
    data,
    method: 'POST',
  });
}

/*
 * 新增、编辑工资项目
 */
export async function addConfigItem(data) {
  return request('/zlb/api/expense/wage/config/item/add', {
    data,
    method: 'POST',
  });
}

/*
 * POST 导出任务提交
 */
export async function exportTask(data) {
  return request('/zlb/api/expense/task/export/submit', {
    data,
    method: 'POST',
  });
}

// 工资条模板-可选项目列表
export const getSalaryTemplateSelection = async params => {
  return query(`/zlb/api/expense/wage/payslip/item-list/${params}`);
};

// 工资条模板-新增
export async function addSalaryTemplate(data) {
  return query('/zlb/api/expense/wage/payslip/add-template', {
    data,
    method: 'POST',
  });
}

// 工资条模板-发送
export async function sendSalaryTemplate(wageFormCode) {
  return query(`/zlb/api/expense/wage/payslip/send/${wageFormCode}`, { method: 'POST' });
}

export async function getSalaryApplyList(data) {
  return query('/zlb/api/expense/wage/payslip/apply-list', {
    data,
    method: 'POST',
  });
}

export async function getSalaryApplyDetailList(data) {
  return query('/zlb/api/expense/wage/payslip/detail-list', {
    data,
    method: 'POST',
  });
}

/**
 * 启用、停用工资项目
 */
export async function changeConfigItemStatus(data) {
  return request('/zlb/api/expense/wage/config/item/change-status', {
    data,
    method: 'PATCH',
  });
}

/**
 * 提交工资项目解析结果
 */
export async function submitAnalyzeRes(data) {
  return request('/zlb/api/expense/wage/config/item/confirm', {
    data,
    method: 'POST',
  });
}
/**
 * 获取工资项目详情
 */
export async function getConfigItemInfo(params) {
  return request(`/zlb/api/expense/wage/config/item/detail/${params.itemCode}`);
}

/**
 * 获取工资项目被多少模版引用
 */
export async function getItemTemplateCount(params) {
  return request(`/zlb/api/expense/wage/config/item/template-count/${params.itemCode}`);
}

/**
 * 修改工资项目详情
 */
export async function editConfigItemInfo(data) {
  return request('/zlb/api/expense/wage/config/item/modify', {
    data,
    method: 'POST',
  });
}
/**
 * 删除工资项目详情
 */
export async function deleteConfigItemInfo(data) {
  return request('/zlb/api/expense/wage/config/item/delete', {
    data,
    method: 'POST',
  });
}

/**
 * 政府经济科目列表接口
 */
export async function queryGovExpendEconomicClassify() {
  return request('/zlb/budget/manage/queryGovExpendEconomicClassify');
}

/**
 * 政府经济科目列表接口
 */
export async function queryDepExpendEconomicClassify(data) {
  return request(`/zlb/budget/manage/query-economy-classify`, {
    method: 'POST',
    data,
  });
}

/**
 * 获取项目类型列表
 */
export async function getItemTypeList() {
  return request('/zlb/api/expense/wage/config/item/type-list');
}

// --------------- 以上是工资项目管理
// --------------- 以下是工资模板管理

/**
 * 工资模板列表
 */
export async function getConfigTemplateList(data) {
  return request('/zlb/api/expense/wage/config/template/list', {
    data,
    method: 'POST',
  });
}

/**
 * 新增、编辑工资模板
 */
export async function addOrEditConfigTemplate(data) {
  return request('/zlb/api/expense/wage/config/template/add-or-modify', {
    data,
    method: 'POST',
  });
}

/**
 * 保存工资模板
 */
export async function saveTemplate(data) {
  return request(' /zlb/api/expense/wage/config/template/save', {
    data,
    method: 'POST',
  });
}

/**
 * 新增模板时，检测模板名称是否可用
 */
export async function checkTemplateName(params) {
  return request('/zlb/api/expense/wage/config/template/check-name', {
    params,
  });
}

/**
 * 预览工资模板
 */
export async function previewTemplate(data) {
  return request('/zlb/api/expense/wage/config/template/preview', {
    data,
    method: 'POST',
  });
}

/**
 * 启用、停用工资模板
 */
export async function changeConfigTemplateStatus(data) {
  return request('/zlb/api/expense/wage/config/template/change-status', {
    data,
    method: 'PATCH',
  });
}

// 查看机构有多少个启用的工资模板
export async function searchActiveCount(params) {
  return request('/zlb/api/expense/wage/config/template/active-count', {
    params,
  });
}

/**
 * 获取工资项目可选列表
 */
export async function getConfigTemplateChooseList(params) {
  return request('/zlb/api/expense/wage/config/item/choose-list', {
    params,
  });
}

/**
 * 新增工资模板时，查询默认的工资项目列表
 */
export async function getConfigTemplateDefaultList(params) {
  return request('/zlb/api/expense/wage/config/item/default-list', {
    params,
    method: 'POST',
  });
}

/**
 * 查看工资模板详情
 */
export async function getConfigTemplateDetail(params) {
  return request(`/zlb/api/expense/wage/config/template/detail/${params.wageTemplateCode}`);
}

/**
 * 删除工资模板
 */
export async function deleteConfigTemplate(data) {
  return request(`/zlb/api/expense/wage/config/template/delete/${data.wageTemplateCode}`, {
    method: 'DELETE',
  });
}

/**
 * 导出工资模板
 */
export async function exportConfigTemplate(params) {
  return request(`/zlb/api/expense/wage/config/template/export/${params.wageTemplateCode}`);
}

/**
 * 下载附件
 */
export async function getDownLoadUrl(params) {
  return request('/zcy/obs/file/getDownLoadUrl', {
    params,
  });
}
// --------------- 以上是工资项目管理

/**
 * 删除发放对象
 */
export async function deletePayee({ id }) {
  return request(`/api/zlbuser/identity/payoff/${id}`, {
    method: 'DELETE',
  });
}

/**
 * 工资支付-设置账户
 */
export async function setPaymentAccount(data) {
  return request(`/zlb/api/expense/wage/payment/account/set`, {
    data,
    method: 'POST',
  });
}

/**
 * 工资支付-初始化
 */
export async function paymentInfoInit(params) {
  return request(`/zlb/api/expense/wage/payment/pay-info/init`, {
    params,
    method: 'get',
  });
}
